import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type VideoImageUploadProps = {
  selectedVideos: any[];
  imageUpload: string[];
  setShowAllMedia: React.Dispatch<React.SetStateAction<number | null>>;
  allMediaUrls: string[];
  handleClick: (index: number) => void;
  thumbnail?: string[];
};
const VideoImageUpload: React.FC<VideoImageUploadProps> = ({
  selectedVideos,
  imageUpload,
  setShowAllMedia,
  allMediaUrls,
  handleClick,
  thumbnail,
}) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null); // Create a ref using useRef
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  if (!selectedVideos || !imageUpload) {
    return null;
  }
  const isBlobUrl = (url: string | undefined) => {
    if (!url) return false;
    return url.startsWith("data:image/jpeg;");
  };

  const _thumbnail = thumbnail || [];
// console.log("_thumbnail ",_thumbnail);

  const isVideoBlobUrl = (url: string) =>
    url.startsWith("blob:") && !url.startsWith("data:image/jpeg;");
  let videoHash: string, thumbnailHash: string;

  return (
    <div className="flex border w-full relative h-full">
      {allMediaUrls && allMediaUrls.length > 4 ? (
        <div className="grid w-full h-full">
          {allMediaUrls?.map((media, index) => {
            const ipfsHashes = media.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [videoHash, thumbnailHash] = ipfsHashes;
            }

            return (
              <div
                className="border relative flex flex-col cursor-pointer h-full"
                onClick={() => {
                  handleClick(index);
                  pause();
                }}
                key={index * 2}
              >
                {media !== null && selectedVideos.indexOf(media) !== -1 ? (
                  isVideoBlobUrl(media) ? (
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={media}
                      width="100%"
                      height="100%"
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={_thumbnail[index]}
                      style={{height: "100%", width: "100%", objectFit: "cover", objectPosition: "center"}}
                    />
                  ) : (
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={ipfsGatewayImage(videoHash)}
                      width="100%"
                      height="100%"
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={ipfsGatewayImage(thumbnailHash)}
                      style={{height: "100%", width: "100%", objectFit: "cover", objectPosition: "center"}}
                    />
                  )
                ) : (
                  media !== null &&
                  imageUpload.indexOf(media) !== -1 && (
                    <img
                      id="imga"
                      src={isBlobUrl(media) ? media : ipfsGatewayImage(media)}
                      alt=""
                      className="w-full object-cover h-full object-center"
                    />
                  )
                )}
              </div>
            );
          })}
        </div>
      ) : allMediaUrls && allMediaUrls?.length > 3 ? (
        <div className="grid grid-cols-2 w-full">
          {allMediaUrls?.map((media, index) => {
            const ipfsHashes = media.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [videoHash, thumbnailHash] = ipfsHashes;
            }
            return (
              <div
                className={`flex w-full border border-solid relative overflow-hidden cursor-pointer`}
                onClick={() => handleClick(index)}
                key={index}
              >
                {media !== null && selectedVideos.includes(media) ? (
                  isVideoBlobUrl(media) ? (
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={media}
                      width="100%"
                      height="100%"
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={_thumbnail[index]}
                    />
                  ) : (
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={ipfsGatewayImage(videoHash)}
                      width="100%"
                      height="100%"
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={ipfsGatewayImage(thumbnailHash)}
                    />
                  )
                ) : (
                  media !== null &&
                  imageUpload.indexOf(media) !== -1 && (
                    <img
                      id="imga"
                      src={isBlobUrl(media) ? media : ipfsGatewayImage(media)}
                      alt=""
                      className="w-full object-cover h-full object-center"
                    />
                  )
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex w-full">
          {allMediaUrls?.length === 2
            ? allMediaUrls?.map((media, index) => {
                const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [videoHash, thumbnailHash] = ipfsHashes;
                }
                return (
                  <div className="flex w-full" key={index * 99}>
                    <div
                      className="h-full cursor-pointer flex justify-between gap-1 w-full overflow-hidden border-2 relative"
                      onClick={() => handleClick(index)}
                    >
                      {media !== null &&
                      selectedVideos.indexOf(media) !== -1 ? (
                        isVideoBlobUrl(media) ? (
                          <ReactPlayer
                            ref={playerRef}
                            key={index}
                            url={media}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={playing}
                            onPlay={play}
                            onPause={pause}
                            volume={1}
                            muted={true}
                            light={_thumbnail[index]}
                          />
                        ) : (
                          <ReactPlayer
                            ref={playerRef}
                            key={index}
                            url={ipfsGatewayImage(videoHash)}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={playing}
                            onPlay={play}
                            onPause={pause}
                            volume={1}
                            muted={true}
                            light={ipfsGatewayImage(thumbnailHash)}
                          />
                        )
                      ) : (
                        media !== null &&
                        imageUpload.indexOf(media) !== -1 && (
                          <img
                            key={index}
                            id="imga"
                            src={
                              isBlobUrl(media) ? media : ipfsGatewayImage(media)
                            }
                            alt=""
                            className="w-full object-cover h-full object-center"
                          />
                        )
                      )}
                    </div>
                  </div>
                );
              })
            : allMediaUrls?.length === 3 && (
                <div className="flex w-full h-full">
                  {allMediaUrls.map((media, index) => {
                    const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                    if (ipfsHashes) {
                      [videoHash, thumbnailHash] = ipfsHashes;
                    }
                    return (
                      index === 0 &&
                      index !== null && (
                        <div className="flex w-full" key={index * 20}>
                          <div
                            className="w-full border relative h-auto overflow-hidden cursor-pointer"
                            onClick={() => handleClick(index)}
                          >
                            {media !== null &&
                            selectedVideos.indexOf(media) !== -1 ? (
                              isVideoBlobUrl(media) ? (
                                <ReactPlayer
                                  ref={playerRef}
                                  key={index}
                                  url={media}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  light={_thumbnail[index]}
                                />
                              ) : (
                                <ReactPlayer
                                  ref={playerRef}
                                  key={index}
                                  url={ipfsGatewayImage(videoHash)}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  light={ipfsGatewayImage(thumbnailHash)}
                                />
                              )
                            ) : (
                              media !== null &&
                              imageUpload.indexOf(media) !== -1 && (
                                <img
                                  id="imga"
                                  src={
                                    isBlobUrl(media)
                                      ? media
                                      : ipfsGatewayImage(media)
                                  }
                                  alt=""
                                  className="w-full object-cover h-full object-center"
                                />
                              )
                            )}
                          </div>
                        </div>
                      )
                    );
                  })}
                  <div className="grid grid-rows-2 h-auto w-full overflow-hidden">
                    {allMediaUrls?.map((media, index) => {
                      const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                      if (ipfsHashes) {
                        [videoHash, thumbnailHash] = ipfsHashes;
                      }
                      return (
                        index !== 0 && (
                          <div
                            className="flex w-full overflow-hidden relative h-auto"
                            key={index + 33}
                          >
                            <div
                              className="w-full flex-1 border flex cursor-pointer"
                              onClick={() => handleClick(index)}
                            >
                              {media !== null &&
                              selectedVideos.indexOf(media) !== -1 ? (
                                isVideoBlobUrl(media) ? (
                                  <ReactPlayer
                                    ref={playerRef}
                                    key={index}
                                    url={media}
                                    width="100%"
                                    height="100%"
                                    controls={true}
                                    playing={playing}
                                    onPlay={play}
                                    onPause={pause}
                                    volume={1}
                                    muted={true}
                                    // muted={true}
                                    light={_thumbnail[index]}
                                  />
                                ) : (
                                  <ReactPlayer
                                    ref={playerRef}
                                    key={index}
                                    url={ipfsGatewayImage(videoHash)}
                                    width="100%"
                                    height="100%"
                                    controls={true}
                                    playing={playing}
                                    onPlay={play}
                                    onPause={pause}
                                    volume={1}
                                    muted={true}
                                    light={ipfsGatewayImage(thumbnailHash)}
                                  />
                                )
                              ) : (
                                media !== null &&
                                imageUpload.indexOf(media) !== -1 && (
                                  <img
                                    id="imga"
                                    src={
                                      isBlobUrl(media)
                                        ? media
                                        : ipfsGatewayImage(media)
                                    }
                                    alt=""
                                    className="w-full object-cover h-full object-center"
                                  />
                                )
                              )}
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                </div>
              )}
        </div>
      )}
    </div>
  );
};

export default VideoImageUpload;
